var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"misc"},[_c('Offers'),_c('Forms'),_vm._v(" Misc ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }